import { Toast } from 'vant';
import CryptoJS from 'crypto-js';

/**
 * @description: 读取location.search中的参数值
 * @param {String} name 名称
 * @return {String} url中的参数的值
 */
const getUrlParam = (name: string) => {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  const search = window.location.search.substr(1);
  const result = search.match(reg);

  if (result != null) {
    return decodeURIComponent(result[2]);
  } else {
    return '';
  }
};

/**
 * @description: 判断是否是iOS平台
 */
const isiOS = () => {
  return /iphone/gi.test(window.navigator.userAgent);
};

/**
 * @description: 获取localStorage
 * @param {String} name - localStorage的名称
 */
const getLocalStorage = (name: string) => {
  return localStorage.getItem(name) || '';
};

/**
 * @description: 存入localStorage
 * @param {String} name - localStorage的名称
 */
const setLocalStorage = (name: string, value: string) => {
  return localStorage.setItem(name, value);
};

/**
 * @description: 删除localStorage
 * @param {String} name - localStorage的名称
 */
const removeLocalStorage = (name: string) => {
  localStorage.removeItem(name);
};

/**
 * @description: 当前服务域名
 */
const DOMAIN = `${window.location.protocol}//${window.location.host}`;


// 选择文本
// eslint-disable-next-line
function selectText(textBox: any, startIndex: number, stopIndex: number) {
  if (textBox.createTextRange) { // ie
    const range = textBox.createTextRange();
    range.collapse(true);
    range.moveStart('character', startIndex); // 起始光标
    range.moveEnd('character', stopIndex - startIndex); // 结束光标
    range.select();// 不兼容ios
  } else { // firefox/chrome
    textBox.setSelectionRange(startIndex, stopIndex);
    textBox.focus();
  }
}

/**
 * @description: 复制内容到剪切板
 * @param text 要复制的文本的内容
 */
const copyText = (text: string) => {
  const textString = text.toString();
  let input: HTMLInputElement | null = document.querySelector('#copy-input');

  if (!input) {
    input = document.createElement('input');
    input.id = 'copy-input';
    input.readOnly = Boolean('readOnly');
    input.style.position = 'absolute';
    input.style.left = '-1000px';
    input.style.zIndex = '-1000';
    document.body.appendChild(input);
  }

  input.value = textString;
  // ios必须先选中 文字且不支持 input.select();
  selectText(input, 0, textString.length);

  if (document.execCommand('copy')) {
    document.execCommand('copy');
    Toast.success('复制成功');
  }

  input.blur();
};

/**
 * @description: 是否运行在webview环境(支付宝小程序或APP)
 */
const isRunInWebview = () => {
  return navigator.userAgent.indexOf('AlipayClient') > -1 || navigator.userAgent.indexOf('uni-app') > -1;
};

/**
 * @description: 是否运行在微信环境
 */
const isWeChartBrowser = () => {
  return /micromessenger/.test(navigator.userAgent.toLowerCase());
};

/**
 * @description: 跳转外部小程序
 */
const skipToMp = (link: string, appId: string) => {
  const extraDataObj = {};

  if (link.indexOf('&query=') !== -1) {
    const extraDataString = link.split('&query=');
    const extraDataArr = decodeURIComponent(extraDataString[1]).split('&');

    for (const i of extraDataArr) {
      extraDataObj[i.split('=')[0]] = i.split('=')[1];
    }
  }

  // web-view跳转小程序
  if (navigator.userAgent.indexOf('AlipayClient') !== -1) {
    const mpOptions = {
      appId: appId,
      path: link,
      extraData: extraDataObj
    };

    // @ts-ignore
    my.postMessage({
      data: mpOptions
    });
  } else {
    window.location.href = `alipays://platformapi/startapp?appId=${appId}&page=${link}`;
  }
};

/**
 * 是否在抖音环境中
 */
const isTikTok = () => {
  return /aweme/.test(navigator.userAgent.toLowerCase());
};

const encrypt = (encryptData: string) => {
  let key = 'GrZwHsvxwdzLdbMb2BQfOOzyueR65gjZ';
  var keyHex = CryptoJS.enc.Utf8.parse(key);
  var encrypted = CryptoJS.AES.encrypt(encryptData, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
};

export {
  getUrlParam,
  isiOS,
  getLocalStorage,
  setLocalStorage,
  removeLocalStorage,
  DOMAIN,
  copyText,
  isRunInWebview,
  isWeChartBrowser,
  skipToMp,
  encrypt,
  isTikTok
};
